var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"department-staff-management"},[_vm._v(" 部门人员管理 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }